import { ContainerTypeEnum } from '../../schemas';

export type ContainerTypeOption = {
  label: string;
  value: string;
};

export const CONTAINER_TYPE_OPTIONS: ContainerTypeOption[] = [
  {
    label: '40-foot High Cube',
    value: ContainerTypeEnum['40HC'],
  },
  {
    label: '20-foot Dry Container',
    value: ContainerTypeEnum['20DC'],
  },
  {
    label: 'Curtain Side',
    value: ContainerTypeEnum.CURTAIN_SIDE,
  },
];

export const DEFAULT_CONTAINER_TYPE = ContainerTypeEnum['40HC'];
